import { render, staticRenderFns } from "./BannedDialog.vue?vue&type=template&id=0fdd6e28&scoped=true"
import script from "./BannedDialog.vue?vue&type=script&lang=js"
export * from "./BannedDialog.vue?vue&type=script&lang=js"
import style0 from "./BannedDialog.vue?vue&type=style&index=0&id=0fdd6e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd6e28",
  null
  
)

export default component.exports